import ConsultantProjectIndexContainer from './ConsultantProjectIndexContainer';
export default ConsultantProjectIndexContainer;